import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://www.bibaelectronics.com";
const DEFAULT_IMAGE = `${SITE}/WebPictures/infra1.jpg`;

/**
 * Per-page <head> tags. Mounted once by RouteSeo, which looks the values up
 * from src/seo/pageMeta.js by pathname -- so individual page components do
 * not need to know anything about SEO.
 *
 * The canonical link is handled separately and globally by src/CanonicalTag.js.
 */
export default function Seo({
  title,
  description,
  path = "",
  image = DEFAULT_IMAGE,
  jsonLd,
  noindex = false,
  breadcrumbs,
}) {
  const url = `${SITE}${path}`;

  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={noindex ? "noindex, follow" : "index, follow"} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="BIBA Electronics Pvt Ltd" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {breadcrumbs && breadcrumbs.length > 0 && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: "Home", item: `${SITE}/` },
              ...breadcrumbs.map((c, i) => ({
                "@type": "ListItem",
                position: i + 2,
                name: c.name,
                item: `${SITE}${c.path}`,
              })),
            ],
          })}
        </script>
      )}

      {jsonLd &&
        (Array.isArray(jsonLd) ? jsonLd : [jsonLd]).map((block, i) => (
          <script key={i} type="application/ld+json">
            {JSON.stringify(block)}
          </script>
        ))}
    </Helmet>
  );
}
